import {useEffect, useState} from "react";
import {AdviceQuery} from "../queries/AdviceQuery";
import {useContext} from "react";
import {AdviceDetailContext} from "../state/adviceDetailContext";

const useAdviceDetail = id => {

    const [isLoading, setIsLoading] = useState(true)
    const {state, dispatch} = useContext(AdviceDetailContext);

    useEffect( () => {
        console.log('useEffect');

        setIsLoading(true)
        state !== undefined && AdviceQuery.findAll().then( advices => {
            console.log(advices);

            const advice = advices.filter(advice => {console.log(advice.id,id);return advice.id == id});
            console.log(advice);
            dispatch({action: "initAdvice", payload: advice[0]})
            setIsLoading(false);
        } ).catch(() => setIsLoading(false))
    }, [])

    const addToFav = id => {
        AdviceQuery.addToFavorite(id).then(() => dispatch({action: "addToFavorite"}))

    }

    const removeFromFav = id => {
        AdviceQuery.removeFromFavorite(id).then(() => dispatch({action: "removeFromFavorite"}))
    }

    return {isLoading, advice : state, addToFav, removeFromFav}
}

export {useAdviceDetail}
